import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import numeral from 'numeral';
import { updateIntl } from 'react-intl-redux';
import { nonScopedClient } from '@/lib/http-client';
import { getNavigatorLanguage } from '@/lib/locale';
import Logger from '@/lib/logger';
import SessionData from '@/lib/session-data';
import { catchError } from '@/redux/actions/error';
import flags from '@/flags';
export var INTL_CHANGE_LOCALE_ERROR = 'INTL_CHANGE_LOCALE_ERROR';
export var INTL_CHANGE_LOCALE_START = 'INTL_CHANGE_LOCALE_START';
export var INTL_CHANGE_LOCALE_SUCCESS = 'INTL_CHANGE_LOCALE_SUCCESS';

var languageMapping = _objectSpread(_objectSpread({}, Object.keys(flags.languages).reduce(function (previousValue, currectValue) {
  if (!flags.languages[currectValue].enabled) return previousValue;
  return _objectSpread(_objectSpread({}, previousValue), {}, _defineProperty({}, flags.languages[currectValue].english.toLowerCase(), currectValue));
}, {})), Object.keys(flags.languages).reduce(function (previousValue, currectValue) {
  if (!flags.languages[currectValue].enabled) return previousValue;
  return _objectSpread(_objectSpread({}, previousValue), {}, _defineProperty({}, currectValue, currectValue));
}, {}));

var numeralMapping = {
  cs: 'cs',
  da: 'da-dk',
  de: 'de',
  en: 'en',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  hr: 'hr',
  hu: 'hu',
  it: 'it',
  lt: 'lv',
  lv: 'lv',
  nb: 'no',
  ro: 'ro',
  ru: 'ru',
  pl: 'pl',
  pt: 'pt-pt',
  sq: 'sq',
  sr: 'hr',
  sv: 'sv',
  tr: 'tr'
};

var http = function http() {
  return nonScopedClient({
    baseURL: '/'
  });
};
/* eslint-disable no-bitwise, no-nested-ternary */


if (true) {
  numeral.register('locale', 'hr', {
    delimiters: {
      thousands: '.',
      decimal: ','
    },
    abbreviations: {
      thousand: 'tis.',
      million: 'mil.',
      billion: 'bil.',
      trillion: 'tril.'
    },
    ordinal: function ordinal() {
      return '.';
    },
    currency: {
      symbol: 'kn'
    }
  });
  numeral.register('locale', 'ro', {
    delimiters: {
      thousands: '.',
      decimal: ','
    },
    abbreviations: {
      thousand: 'k',
      million: 'mil',
      billion: 'mld',
      trillion: 't'
    },
    ordinal: function ordinal() {
      return '';
    },
    currency: {
      symbol: 'RON'
    }
  });
  numeral.register('locale', 'sv', {
    delimiters: {
      thousands: ' ',
      decimal: ','
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'md',
      trillion: 'bn'
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return ~~(number % 100 / 10) === 1 ? ':a' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
    },
    currency: {
      symbol: 'SKR'
    }
  });
  numeral.register('locale', 'sq', {
    delimiters: {
      thousands: '.',
      decimal: ','
    },
    abbreviations: {
      thousand: 'mijë',
      million: 'Mln',
      billion: 'Mld',
      trillion: 'Tln'
    },
    ordinal: function ordinal(number) {
      if (number % 10 === 4 && number !== 14) {
        return '–t';
      }

      return '–ë';
    },
    currency: {
      symbol: 'ALL'
    }
  });
}
/* eslint-enable no-bitwise, no-nested-ternary */


export var getLocaleData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http().get("/locales/".concat(locale, ".json"));

          case 2:
            return _context.abrupt("return", _context.sent.data);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getLocaleData(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getLocaleDataPluralRules = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (Intl.PluralRules) {
              _context2.next = 26;
              break;
            }

            _context2.t0 = locale;
            _context2.next = _context2.t0 === 'cs' ? 4 : _context2.t0 === 'da' ? 5 : _context2.t0 === 'de' ? 6 : _context2.t0 === 'en' ? 7 : _context2.t0 === 'es' ? 8 : _context2.t0 === 'fi' ? 9 : _context2.t0 === 'fr' ? 10 : _context2.t0 === 'hr' ? 11 : _context2.t0 === 'hu' ? 12 : _context2.t0 === 'it' ? 13 : _context2.t0 === 'lt' ? 14 : _context2.t0 === 'lv' ? 15 : _context2.t0 === 'nb' ? 16 : _context2.t0 === 'pl' ? 17 : _context2.t0 === 'pt' ? 18 : _context2.t0 === 'ro' ? 19 : _context2.t0 === 'ru' ? 20 : _context2.t0 === 'sq' ? 21 : _context2.t0 === 'sr' ? 22 : _context2.t0 === 'sv' ? 23 : _context2.t0 === 'tr' ? 24 : 25;
            break;

          case 4:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/cs'));

          case 5:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/da'));

          case 6:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/de'));

          case 7:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/en'));

          case 8:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/es'));

          case 9:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/fi'));

          case 10:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/fr'));

          case 11:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/hr'));

          case 12:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/hu'));

          case 13:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/it'));

          case 14:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/lt'));

          case 15:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/lv'));

          case 16:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/nb'));

          case 17:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/pl'));

          case 18:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/pt'));

          case 19:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/ro'));

          case 20:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/ru'));

          case 21:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/sq'));

          case 22:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/sr'));

          case 23:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/sv'));

          case 24:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/tr'));

          case 25:
            return _context2.abrupt("return", import('@formatjs/intl-pluralrules/locale-data/en'));

          case 26:
            return _context2.abrupt("return", Promise.resolve());

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getLocaleDataPluralRules(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var getLocaleDataRelativeTimeFormat = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(locale) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (Intl.RelativeTimeFormat) {
              _context3.next = 26;
              break;
            }

            _context3.t0 = locale;
            _context3.next = _context3.t0 === 'cs' ? 4 : _context3.t0 === 'da' ? 5 : _context3.t0 === 'de' ? 6 : _context3.t0 === 'en' ? 7 : _context3.t0 === 'es' ? 8 : _context3.t0 === 'fi' ? 9 : _context3.t0 === 'fr' ? 10 : _context3.t0 === 'hr' ? 11 : _context3.t0 === 'hu' ? 12 : _context3.t0 === 'it' ? 13 : _context3.t0 === 'lt' ? 14 : _context3.t0 === 'lv' ? 15 : _context3.t0 === 'nb' ? 16 : _context3.t0 === 'pl' ? 17 : _context3.t0 === 'pt' ? 18 : _context3.t0 === 'ro' ? 19 : _context3.t0 === 'ru' ? 20 : _context3.t0 === 'sq' ? 21 : _context3.t0 === 'sr' ? 22 : _context3.t0 === 'sv' ? 23 : _context3.t0 === 'tr' ? 24 : 25;
            break;

          case 4:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/cs'));

          case 5:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/da'));

          case 6:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/de'));

          case 7:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/en'));

          case 8:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/es'));

          case 9:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/fi'));

          case 10:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/fr'));

          case 11:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/hr'));

          case 12:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/hu'));

          case 13:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/it'));

          case 14:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/lt'));

          case 15:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/lv'));

          case 16:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/nb'));

          case 17:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/pl'));

          case 18:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/pt'));

          case 19:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/ro'));

          case 20:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/ru'));

          case 21:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/sq'));

          case 22:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/sr'));

          case 23:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/sv'));

          case 24:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/tr'));

          case 25:
            return _context3.abrupt("return", import('@formatjs/intl-relativetimeformat/locale-data/en'));

          case 26:
            return _context3.abrupt("return", Promise.resolve());

          case 27:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getLocaleDataRelativeTimeFormat(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getNumeralData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(locale) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(locale in numeral.locales)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", Promise.resolve(numeral.locales[locale]));

          case 2:
            _context4.t0 = locale;
            _context4.next = _context4.t0 === 'cs' ? 5 : _context4.t0 === 'da-dk' ? 8 : _context4.t0 === 'de' ? 11 : _context4.t0 === 'en' ? 14 : _context4.t0 === 'es' ? 17 : _context4.t0 === 'fi' ? 20 : _context4.t0 === 'fr' ? 23 : _context4.t0 === 'hr' ? 26 : _context4.t0 === 'hu' ? 29 : _context4.t0 === 'it' ? 32 : _context4.t0 === 'lv' ? 35 : _context4.t0 === 'no' ? 38 : _context4.t0 === 'pl' ? 41 : _context4.t0 === 'pt-pt' ? 44 : _context4.t0 === 'ru' ? 47 : _context4.t0 === 'tr' ? 50 : _context4.t0 === 'ro' ? 53 : _context4.t0 === 'sq' ? 53 : _context4.t0 === 'sv' ? 53 : 53;
            break;

          case 5:
            _context4.next = 7;
            return import('numeral/locales/cs.js');

          case 7:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 8:
            _context4.next = 10;
            return import('numeral/locales/da-dk');

          case 10:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 11:
            _context4.next = 13;
            return import('numeral/locales/de');

          case 13:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 14:
            _context4.next = 16;
            return import('numeral/locales/en-gb');

          case 16:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 17:
            _context4.next = 19;
            return import('numeral/locales/es.js');

          case 19:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 20:
            _context4.next = 22;
            return import('numeral/locales/fi.js');

          case 22:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 23:
            _context4.next = 25;
            return import('numeral/locales/fr.js');

          case 25:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 26:
            _context4.next = 28;
            return import('numeral/locales/en-gb.js');

          case 28:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 29:
            _context4.next = 31;
            return import('numeral/locales/hu.js');

          case 31:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 32:
            _context4.next = 34;
            return import('numeral/locales/it.js');

          case 34:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 35:
            _context4.next = 37;
            return import('numeral/locales/lv.js');

          case 37:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 38:
            _context4.next = 40;
            return import('numeral/locales/no.js');

          case 40:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 41:
            _context4.next = 43;
            return import('numeral/locales/pl.js');

          case 43:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 44:
            _context4.next = 46;
            return import('numeral/locales/pt-pt');

          case 46:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 47:
            _context4.next = 49;
            return import('numeral/locales/ru.js');

          case 49:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 50:
            _context4.next = 52;
            return import('numeral/locales/tr.js');

          case 52:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 53:
            _context4.next = 55;
            return import('numeral/locales/en-gb');

          case 55:
            return _context4.abrupt("return", _context4.sent["default"]);

          case 56:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getNumeralData(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var changeLocaleError = function changeLocaleError() {
  return {
    type: INTL_CHANGE_LOCALE_ERROR
  };
};
export var changeLocaleStart = function changeLocaleStart() {
  return {
    type: INTL_CHANGE_LOCALE_START
  };
};
export var changeLocaleSuccess = function changeLocaleSuccess(locale) {
  return {
    type: INTL_CHANGE_LOCALE_SUCCESS,
    payload: {
      locale: locale
    }
  };
};
export function changeLocale(preferredLanguage) {
  var checkLanguageAvailability = function checkLanguageAvailability(language) {
    return language in languageMapping ? languageMapping[language] : null;
  };

  return function (dispatch, getState) {
    var _getState = getState(),
        intl = _getState.intl;

    var fallbackLanguage = 'en';
    var navigatorLanguage = getNavigatorLanguage(window.navigator) || null;
    var sessionLanguage = SessionData.language();
    var locale = checkLanguageAvailability(preferredLanguage);

    if (!locale) {
      locale = checkLanguageAvailability(sessionLanguage);
    }

    if (!locale) {
      locale = checkLanguageAvailability(navigatorLanguage);
    }

    if (!locale) {
      Logger.warning("Unknown language '".concat(locale, "', fallbacks to '").concat(fallbackLanguage, "'"), {
        navigatorLanguage: navigatorLanguage,
        preferredLanguage: preferredLanguage,
        sessionLanguage: sessionLanguage
      });
      locale = fallbackLanguage;
    }

    var numeralLocale = locale in numeralMapping ? numeralMapping[locale] : numeralMapping[fallbackLanguage];
    dispatch(changeLocaleStart());

    if (intl.locale === locale) {
      return dispatch(changeLocaleSuccess(locale));
    }

    return Promise.all([getLocaleData(locale), getNumeralData(numeralLocale), getLocaleDataPluralRules(locale), getLocaleDataRelativeTimeFormat(locale)]).then(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          messages = _ref6[0],
          numeralLocaleData = _ref6[1];

      numeral.locale(numeralLocale, numeralLocaleData);
      dispatch(updateIntl({
        locale: locale,
        messages: messages
      }));
      dispatch(changeLocaleSuccess(locale));
      SessionData.setLanguage(locale);
    })["catch"](function (response) {
      dispatch(changeLocaleError());
      dispatch(catchError(response, {
        navigatorLanguage: navigatorLanguage,
        preferredLanguage: preferredLanguage,
        sessionLanguage: sessionLanguage
      }));
    });
  };
}
export var fetchLocaleData = function fetchLocaleData(locale) {
  return Promise.all([getLocaleData(locale), getLocaleDataPluralRules(locale), getLocaleDataRelativeTimeFormat(locale)]);
};